/**
 * Atelier Concierge "Live chat": opens the Shopify Inbox window (<shopify-chat>, from the Inbox app
 * embed) instead of following the link. Without Inbox on the page, or if it fails to load in time,
 * the link's own destination (WhatsApp or the message form) is used.
 */

const CHAT_TAG = 'shopify-chat';
const LOAD_TIMEOUT = 2500;

/** @returns {Promise<(HTMLElement & { show?: () => unknown, open?: boolean }) | null>} */
async function getChat() {
  const chat = document.querySelector(CHAT_TAG);
  if (!(chat instanceof HTMLElement)) return null;
  const defined = customElements.whenDefined(CHAT_TAG).then(() => true);
  const timeout = new Promise((resolve) => setTimeout(() => resolve(false), LOAD_TIMEOUT));
  return (await Promise.race([defined, timeout])) ? chat : null;
}

document.addEventListener('click', async (event) => {
  const link = event.target instanceof Element ? event.target.closest('[data-concierge-live-chat]') : null;
  if (!(link instanceof HTMLAnchorElement) || !document.querySelector(CHAT_TAG)) return;

  event.preventDefault();
  link.closest('[popover]')?.hidePopover?.();

  const chat = await getChat();
  if (chat && typeof chat.show === 'function') {
    chat.show();
  } else if (chat && 'open' in chat) {
    chat.open = true;
  } else {
    window.location.href = link.href;
  }
});
